import React from 'react';
import { useDonorProfile } from '../../api';
import { useLoginToastContext } from '../../providers/LoginToastProvider';
import { DonorAvatar } from '../ui';
import { assetUrl } from '../../utils/webConfig';
import { IconButton, Snackbar } from '@mui/material';

export const LoginToast: React.FC = () => {
    const { donorProfile } = useDonorProfile();
    const { donor } = donorProfile || {};
    const { showLoginToast, handleCloseLoginToast } = useLoginToastContext();

    return (
        <Snackbar
            id="login-toast"
            open={showLoginToast && !!donor}
            autoHideDuration={5000}
            onClose={handleCloseLoginToast}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            className="rounded-full bg-white p-1.5 shadow-high overflow-hidden -translate-y-5"
        >
            <div
                id="login-toast-content"
                className="inline-flex items-center "
            >
                <DonorAvatar
                    id="login-toast-avatar"
                    src={donor?.pictureUrl}
                    className="mr-3 h-10 w-10 rounded-full"
                />
                <div id="login-toast-text">
                    <span
                        id="login-toast-greeting"
                        className="inline-block text-base font-extrabold leading-5 text-secondary"
                    >
                        Welcome,
                    </span>
                    <span
                        id="login-toast-donor-name"
                        className="inline-block pl-1 text-base font-extrabold leading-5 text-primary"
                    >
                        {donor?.name}
                    </span>
                </div>
                <IconButton
                    id="login-toast-close-button"
                    type="button"
                    aria-label="Close"
                    onClick={handleCloseLoginToast}
                    className="ml-5 cursor-pointer"
                    size="large"
                >
                    <img
                        id="login-toast-close-icon"
                        src={assetUrl('/images/svg/close-icon.svg')}
                        alt=""
                        className="h-4 w-4"
                    />
                </IconButton>
            </div>
        </Snackbar>
    );
};
